module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.af4cdc75.webp";